import React from 'react';
import { FullScreenModal } from 'lib/components/FullScreenModal';
import { MdClose } from 'react-icons/md';
import {
  LinkBtn,
  LinkWrapper,
} from 'app/pages/library/videos/videoList/components/SendAndShare';
import { Title } from 'lib/components/toasts/index.styled';
import { VINReelsTable } from './VINReelsTable';
import { useTranslation } from 'react-i18next';

type Props = {
  handleModalClose: () => void;
  onCopy?: () => void;
};

export const ModalVinReels = ({ handleModalClose, onCopy }: Props) => {
  const { t } = useTranslation();
  return (
    <FullScreenModal
      headerLeft={
        <LinkWrapper>
          <LinkBtn onClick={handleModalClose}>
            <MdClose size='18' />
            <span>{t('Close')}</span>
          </LinkBtn>
        </LinkWrapper>
      }
      headerCenter={<Title>{t('Available VIN Reels')}</Title>}
    >
      <VINReelsTable onCopy={onCopy} handleModalClose={handleModalClose} />
    </FullScreenModal>
  );
};
